import { render, staticRenderFns } from "./Issue.vue?vue&type=template&id=40df55fc&scoped=true&"
import script from "./Issue.vue?vue&type=script&lang=js&"
export * from "./Issue.vue?vue&type=script&lang=js&"
import style0 from "./Issue.vue?vue&type=style&index=0&id=40df55fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40df55fc",
  null
  
)

export default component.exports